import { render, staticRenderFns } from "./RedirectLoading.vue?vue&type=template&id=749d5697&scoped=true"
import script from "./RedirectLoading.vue?vue&type=script&lang=js"
export * from "./RedirectLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d5697",
  null
  
)

export default component.exports